import Vue from "vue";

Vue.component("listings-vue", {
  mounted() {
    function setHeights() {
      var ul1 = document.querySelector('.listings__content');
      var ul2 = document.querySelector('.listings__overlay-year-data');
      var liElements1 = ul1.getElementsByTagName('li');
      var liElements2 = ul2.getElementsByTagName('li');

      for (var i = 0; i < liElements1.length; i++) {
        var li1 = liElements1[i];
        var li2 = liElements2[i + 1];
        var liHeight = li1.clientHeight;
        li2.style.height = liHeight + 'px';
        //remove the border and padding from the last accordion item
        if (i === liElements1.length - 1) {
          var summaryAccordionContent = li1.querySelector('.summary-accordion__content');
          if (summaryAccordionContent) {
            summaryAccordionContent.style.border = 'none';
            summaryAccordionContent.style.paddingBottom = '0px';
            summaryAccordionContent.style.marginBottom = '0px';
          }
        }
      }
    }

    //year text click functionality
    document.addEventListener("DOMContentLoaded", function() {
      var yearLabelOverlay = document.querySelector(".listings__year-label");
      var yearLabel = document.querySelector('.listings__heading-year');
      var ulElement = document.querySelector(".listings__overlay-year-data");
      if (yearLabelOverlay || yearLabel || ulElement) {
        yearLabelOverlay.addEventListener("click", function() {
          ulElement.classList.toggle("listings__overlay-year-data--open");
        });
        yearLabel.addEventListener("click", function() {
          ulElement.classList.toggle("listings__overlay-year-data--open");
        });
        window.addEventListener('resize', setHeights);
        var observer = new MutationObserver(setHeights);
        var ul1 = document.querySelector('.listings__content');
        observer.observe(ul1, { attributes: true, subtree: true, childList: true });
        setHeights();
      }
    });
    // add tabindex to the dropdown items for web accessibility
    var listElements = document.querySelectorAll(".listings__top-sort .dropdown-list li");
    var buttonElements = document.querySelectorAll(".listings__top-sort .dropdown-list li button");
    buttonElements.forEach(function(button) {
      button.setAttribute("tabindex", "-1");
    });
    listElements.forEach(function(item) {
      item.setAttribute("tabindex", "0");
    });

    //add tabindex for pagination dropdown
    var listElements = document.querySelectorAll(".pagination__mobile .dropdown-list li");
    var buttonElements = document.querySelectorAll(".pagination__mobile .dropdown-list li button");
    buttonElements.forEach(function(button) {
      button.setAttribute("tabindex", "-1");
    });
    listElements.forEach(function(item) {
      item.setAttribute("tabindex", "0");
    });
    //open accordion on title click
    const contentItems = this.$el.querySelectorAll('.listings__content-item');
    contentItems.forEach((item) => {
      const link = item.querySelector('.listings__content-link');
      const summaryAccordionContent = item.querySelector('.summary-accordion__content');
      const title = item.querySelector(".summary-accordion__title button");
      const accordionContent = item.querySelector(".summary-accordion__content");
      const svgIcon = title.querySelector("button svg");

      link.addEventListener('click', function(event) {
        event.preventDefault();
        summaryAccordionContent.classList.toggle('active');
        svgIcon.classList.toggle("rotate-down", !accordionContent.classList.contains("active"));
        svgIcon.classList.toggle("rotate-up", accordionContent.classList.contains("active"));
      });
    });
  }
});
